import { createContext, useState } from 'react';

const OrganizacionContext = createContext();

export const OrganizacionContextProvider = ({ children }) => {

    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(false);

    const [message, setMessage] = useState({
        message: '',
        status: 200
    });

    return (
        <OrganizacionContext.Provider
            value={{
                organizations,
                setOrganizations,
                loading,
                setLoading,
                message,
                setMessage
            }}
        >
            {children}
        </OrganizacionContext.Provider>
    );
};

export default OrganizacionContext;
